import {ValidatorFn} from "@angular/forms";
import {FinancialPerformanceRecord} from "../../../../models/asset/financial-performance-record";
import {ScenarioType} from "../../../../../shared/model/scenario-type";
import {QuickForecastMode, QuickForecastSeeds} from "../../../../generated-sources/api";

export {QuickForecastMode, QuickForecastSeeds};

export const QUICK_FORECAST_MODE_DEFAULT: QuickForecastMode = "ADDITIVE";

export type QuickForecastMetricKey =
    | "revenueGrowth"
    | "margin"
    | "evOverEarningBase"
    | "debtRepaymentCapacity";

export interface MetricDescriptor {
    readonly key: QuickForecastMetricKey;
    /** Row label resolver — returns the user-facing label given the active earning base. */
    readonly label: (earningBase: string) => string;
    /** Suffix shown next to the 1st-year input — `%` for percents, `x` for multiples. */
    readonly firstYearSuffix: "%" | "x";
    /**
     * Suffix shown next to the YoY input. Mode-aware because EV/Base YoY is a multiple delta in
     * Additive (`x`) but a growth rate in Compound (`%`).
     */
    readonly yoySuffix: (mode: QuickForecastMode) => "%" | "x";
    readonly firstYearValidators: ValidatorFn[];
    readonly yoyValidators: ValidatorFn[];
}

export interface ApplyQuickForecastPayload {
    readonly assetId: number;
    readonly assetValuationId: number;
    readonly scenarioId: number;
    readonly scenarioType: ScenarioType;
    readonly earningBase: string;
    readonly forecastRecords: FinancialPerformanceRecord[];
    readonly seeds: QuickForecastSeeds;
    readonly mode: QuickForecastMode;
}
